import Carousel from "./components/Carousel";

export type {
  TCarouselProps,
  ICarouselInstance,
  IComputedDirectionTypes,
  CarouselRenderItem,
} from "./types";
export type { TAnimationStyle } from "./components/BaseLayout";
export type { ILayoutConfig } from "./layouts/stack";

export default Carousel;
